import cx from "classnames";

import style from "./MenuBar.module.scss";
import { GreyButton, TransparentButton } from "../Buttons";
import React from "react";

const MenuButton = ({ id, text, onClick, isActive }) => {
  return (
    <TransparentButton
      id={id}
      onClick={onClick}
      className={cx("button", {
        "button--active":
          typeof isActive === "function" ? isActive() : isActive,
      })}
    >
      {text}
    </TransparentButton>
  );
};

const MenuBar = ({ buttons }) => {
  return (
    <div className={cx("menu-bar", style.bar)}>
      {buttons.map((button) => (
        <MenuButton {...button} />
      ))}
    </div>
  );
};

export default MenuBar;
